import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ScheduleMasterItem } from '../../../../api/model';
import Modal from '../../../modules/Modal';

type Props = {
  scheduleMaster: ScheduleMasterItem;
  open: boolean;
  onClose: () => void;
  setFormValues: (params: ScheduleMasterItem) => void;
};
function MasterScheduleMainFormModal({ open, onClose, setFormValues, scheduleMaster }: Props) {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  const { register, getValues } = useForm<ScheduleMasterItem>({
    defaultValues: scheduleMaster,
  });

  const handleSubmit = () => {
    setFormValues(getValues());
    handleClose();
  };

  return (
    <Modal active={open} additionalClassName="popupfr800" displayCloseButton onClose={handleClose}>
      <div className="pop-tablefr1">
        <div>
          <table>
            <tbody>
              <tr>
                <th>
                  <label htmlFor="master_division">{t('分類')}</label>
                </th>
                <td>{scheduleMaster.master_division}</td>
              </tr>
              <tr>
                <th>
                  <label htmlFor="milestone">{t('マイルストーン')}</label>
                </th>
                <td>
                  <input type="text" {...register('milestone')} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <table>
            <tbody>
              <tr>
                <th>
                  <label htmlFor="process">{t('工程')}</label>
                </th>
                <td>{scheduleMaster.process}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="pop-tablefr1">
        <div>
          <table>
            <tbody>
              <tr>
                <th>
                  <label htmlFor="period_fmc_with_ka">{t('FMC/KA有')}</label>
                </th>
                <td>
                  <input type="text" {...register('period_fmc_with_ka')} />
                </td>
              </tr>
              <tr>
                <th>
                  <label htmlFor="period_fmc_without_ka">{t('FMC/KA無')}</label>
                </th>
                <td>
                  <input type="text" {...register('period_fmc_without_ka')} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <table>
            <tbody>
              <tr>
                <th>
                  <label htmlFor="period_mmc_with_ka">{t('MMC/KA有')}</label>
                </th>
                <td>
                  <input type="text" {...register('period_mmc_with_ka')} />
                </td>
              </tr>
              <tr>
                <th>
                  <label htmlFor="period_mmc_without_ka">{t('MMC/KA無')}</label>
                </th>
                <td>
                  <input type="number" {...register('period_mmc_without_ka')} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="threadfr2 mb20">
        <label htmlFor="message">{t('メッセージ')}</label>
        <div>
          <textarea rows={10} cols={33} {...register('message')} />
        </div>
      </div>
      <div className="messagead">
        <p>{t('**にすると、**の部分はマイルストーン名に置換されます。')}</p>
      </div>
      <div className="btnfr btnfr2 mb0 mt0">
        <div>
          <span className="btn2 btnbg-g mr10" onClick={() => handleClose()}>
            <span className="modal-close2">{t('キャンセル')}</span>
          </span>
          <span>
            <input type="submit" value="OK" className="btn1 lsp1" onClick={() => handleSubmit()} />
          </span>{' '}
        </div>
      </div>
    </Modal>
  );
}

export { MasterScheduleMainFormModal };
